// extracted by mini-css-extract-plugin
export default {"iframe_cont":"iframe_iframe_cont__8MRW6","loading_cont":"iframe_loading_cont__-CzG-"};